import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePaymentMethods(enterpriseId) {
  const [paymentMethods, setPaymentMethods] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.enterprises.payment_methods(enterpriseId))
      .then((response) => {
        setPaymentMethods(response.data.data);
      });
  }, []);

  return paymentMethods;
}
